export const dndOptions = {
  enableMouseEvents: true,
};

export const dndItemTypes = {
  BLENDING_LETTER_CARD: "BLENDING_LETTER_CARD",
  BLENDING_ONBOARD_LETTER_CARD: "BLENDING_ONBOARD_LETTER_CARD",
  HIGH_FREQUENCY_WORD_CARD: "HIGH_FREQUENCY_WORD_CARD",
  PHONEME_BASKET_ITEM: "PHONEME_BASKET_ITEM",
};
